/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const whatsAppAccountDataSchema = z.object({
	id: z.string(),
	organisationId: z.string(),
	isActive: z.boolean(),
	phoneNumber: z.string().nullable(),
	displayName: z.string().nullable(),
	hasPaymentMethod: z.boolean().nullable(),
	firstContactAutomationEnabled: z.boolean(),
	firstContactTemplateId: z.string().nullable(),
	firstContactScoreThreshold: z.number().nullable(),
	firstContactScoreThresholdResolved: z.number(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
})

export type WhatsAppAccountDataSchema = z.infer<typeof whatsAppAccountDataSchema>
